/* eslint-disable */
import { node, icon } from "~/util/dom";
import { _ } from "~/i18n";

/**
 * Contextmenu pro novy batuzek.
 * Mozne jmena: share (sdileni), duplicate (duplikace), move-to-folder (pridat do slozky), navigate (navigace, routovac), rename (prejmenovat, editovat), multiple (hromadne operace), delete (mazani)
 * signaly:
 * clickCb(type)
 */
export default class MyMapsContextMenu {
	_dom: {
		container: HTMLUListElement;
		[key: string]: HTMLElement;
	}
	_opened: boolean;
	_items: Array<{
		el: HTMLLIElement;
		name: string;
	}>;
	_opts: {
		clickCb?: Function, // callback pri kliknuti na item
		parent?: HTMLElement, // pripojit do DOMu?
		closestSelector?: string, // třída tlačítka (abych věděl, že klikám na jedno z tlačítek)
		names?: Array<string> // jednotlive jmena tlacitek
		[key: string]: any;
	}

	constructor(opts) {
		this._opts = Object.assign({
			clickCb: null,
			parent: null,
			closestSelector: "",
			names: [],
		}, opts);
		this._dom = {
			container: node("ul", { className: "mymap-contextmenu" }) as HTMLUListElement,
		};
		this._items = [];
		this._opened = false;
		this._create();
	}

	/**
	 * Ziskani obalu.
	 *
	 * @return {Element}
	 */
	get container() {
		return this._dom.container;
	}

	/**
	 * Nastaveni rodice, kam se ma contextmenu pripnout.
	 *
	 * @param {Element} parent Rodic
	 */
	set parent(parent) {
		this._opts.parent = parent;
	}

	/**
	 * Nastaví selektor tlačítek
	 * @type {String} selektor tlačítka
	 */
	set closestSelector(selector: string) {
		this._opts.closestSelector = selector;
	}

	/**
	 * Je menu otevrene?
	 *
	 * @return {Boolean}
	 */
	isOpen() {
		return this._opened;
	}

	/**
	 * Otevreni - naplneni dat.
	 */
	open() {
		if (this._opened) return;

		// jinak se hnedka provedl handleEvent
		setTimeout(() => {
			document.addEventListener("click", this, false);
		}, 0);

		document.addEventListener("keydown", this);

		this._items.forEach(item => {
			this._dom.container.appendChild(item.el);
		});

		if (this._opts.parent) {
			this._opts.parent.appendChild(this._dom.container);
		}

		this._opened = true;
	}

	/**
	 * Zavreni - odepnuti dat.
	 */
	close() {
		if (!this._opened) return;

		document.removeEventListener("click", this, false);
		document.removeEventListener("keydown", this);

		this._items.forEach(item => {
			item.el.remove();
		});

		if (this._opts.parent) {
			this._dom.container.remove();
		}

		this._opened = false;
	}

	/**
	 * Prepinani zavreni/otevreni.
	 */
	toggle() {
		if (this._opened) {
			this.close();
		}
		else {
			this.open();
		}
	}

	handleEvent(e: Event) {
		if (!this._opened) return;

		switch (e.type) {
			case "click":
				//klikám na svoje tlačítko nebo jiné tlačítko
				const target = (e as MouseEvent).target as HTMLLIElement;

				if ((this._opts.parent && this._opts.parent.contains(target)) || !(this._opts.closestSelector && target.closest(this._opts.closestSelector))) {
					e.stopPropagation();
				}
				e.preventDefault();

				if (this._dom.container.contains(target)) {
					let len = this._items.length;

					for (let i = 0; i < len; i++) {
						let item = this._items[i];

						if (item.el.contains(target)) {
							if (this._opts.clickCb && typeof this._opts.clickCb === "function") {
								this._opts.clickCb(item.name);
								this.close();
							}
							break;
						}
					}
				}
				else {
					this.close();
				}
				break;

			case "keydown":
				e.stopPropagation();
				e.preventDefault();

				let keyCode = (e as KeyboardEvent).which || (e as KeyboardEvent).keyCode;

				// esc
				if (keyCode == 27) {
					this.close();
				}
				break;
		}
	}

	/**
	 * Vytvorime polozky
	 *
	 * @param {Array} names Pole s nazvama tlacitek
	 */
	_create(names?: Array<string>) {
		let source = names && Array.isArray(names) ? names : this._opts.names;
		source.forEach(name => {
			this._items.push({
				el: this._createItem(name),
				name
			});
		});
	}

	/**
	 * Vytvoreni itemu a naplneni do pole.
	 */
	_createItem(name: string): HTMLLIElement {
		let el = node("li", { className: "contextmenu-item" });
		let iconElm = node("span", { className: "icon" });
		iconElm.appendChild(icon(this._getIconName(name))); // hack kvuli tomu, jak natvrdo je menu zadratovane
		let title = node("h3", { className: "name", textContent: _("mymap.contextMenu." + name) });

		el.appendChild(iconElm);
		el.appendChild(title);

		return el;
	}

	_getIconName(name: string): string {
		switch(name) {
			case "add-to-folder":
			case "link-to-folder":
				return "move-to-folder";

			case "remove":
				return "delete";

			case "update":
				return "edit";

			case "import":
				return "import2";

			case "export":
			case "download":
				return "export2";
		}

		return name;
	}
}
